module.exports = __webpack_public_path__ + "img/logo-title.fa2ba330.png";